import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../root/routes";
import { WorkflowSetupPageWrapper } from "./WorkflowSetupPageWrapper";

export const ProfilingInformationInstructionsPage = () => {
  const history = useHistory();

  return (
    <WorkflowSetupPageWrapper
      selectedTabKey="profiling-information-request"
      nextOnClick={() => history.push(Routes.organization.requestHandling.requestToPortability)}
      nextDisabled={false}
      nextContent="Next"
    >
      <></>
    </WorkflowSetupPageWrapper>
  );
};
